<div class="header">
  <!-- <button printSectionId="printlist" ngxPrint class="btn btn-success" style="float: right; margin-top: -6px;">Print
    Pick-List</button> -->
    <button (click)="triggerPrintPickList()" class="btn btn-success" style="float: right; margin-top: -6px;">
  Print Pick-List
</button>

  <!-- <button (click)="printPackedList()" *ngIf="finishedScan" class="btn btn-warning printPackedList">Print Packed-List</button> -->
  <h3>SafeScan-BATCH</h3>
</div>
<hr>
<div class="main-section">

  <!-- <input type="text" id="scan-result"> -->
  <div class="scanner">
    <!-- <div class="scanBtn"> -->
    <!-- <button (click)="startScanner()" class="btn btn-primary startScanner" *ngIf="!isScannerActive &&!finishedScan">Start</button> -->
    <!-- <button (click)="stopScanner()" *ngIf="isScannerActive &&!finishedScan" class="btn btn-danger stopScanner">Stop</button> -->
    <!-- </div> -->
    <!-- <div>
      <input
      #barcodeInput
      type="text"
      (keyup.enter)="handleBarcode(barcodeInput)"
      id="barcodeinput" 
      autofocus
      (blur)="barcodeInput.focus()"/>
    </div>-->
    <div style="display: flex; align-items: center;">
      <input #barcodeInput type="text" (keyup.enter)="handleBarcode(barcodeInput)" id="barcodeinput"
        class="form-control" style="width: 250px;" autofocus (blur)="barcodeInput.focus()" *ngIf="!finishedScan" />
    </div>
    <label *ngIf="isScannerActive && !finishedScan" style="font-weight: bold;">Scanning Barcode</label>
    <!-- <div class="video" *ngIf="!finishedScan">
      <p class="camera-status" style="font-size: smaller;">{{ cameraPermissionStatus }}</p>
      <img src="/images/no-video.png" height="50px" width="50px" alt="" *ngIf="!cameraGranted">
      <zxing-scanner *ngIf="isScannerActive" (scanSuccess)="onScanResult($event)" [formats]="barcodeFormats">
      </zxing-scanner>
    </div>
  </div> -->
  </div>
  <!-- medications -->
  <app-scanmedication [isStartBtnClicked]="isStartBtnClicked"
    (isScanFinished)="isScanFinished($event)"></app-scanmedication>
  <!-- print list -->
  <!-- <div id="printlist" class="printlist">
    <div class="container">
      <h2>Batch pickup list</h2>
      <table cellpadding="10">
        <thead>
          <tr>
            <th>Stock Item</th>
            <th>Prescription ID</th>
            <th>Quantity</th>
            <th>Picked Y/N?</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let medication of objectKeys(groupedMedications)">
            <td>{{ medication }}</td>
            <td>{{ groupedMedications[medication].prescriptionIds.join(', ') }}</td>
            <td>{{ groupedMedications[medication].quantity }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div> -->
  <div id="printlist" class="printlist" style="display: none;">
  <div class="print-container">

    <div class="print-top-bar">
      <div class="print-date">
        {{ todayDate }}
      </div>
      <div class="print-logos">
        <img src="../../assets/images/mclernons.png" class="print-logo" />
        <img src="../../assets/images/safescan.png" class="print-logo" />
      </div>
    </div>

    <hr />

    <h2 class="print-title">Batch Pick List</h2>

    <table>
      <thead>
        <tr>
          <th class="col-stock">Stock Item</th>
          <th class="col-prescription">Prescription ID</th>
          <th class="col-qty">Quantity</th>
          <th class="col-picked">Picked Y/N</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let medication of objectKeys(groupedMedications)">
          <td>{{ medication }}</td>
          <td>
            Ending -{{ getLastChars(groupedMedications[medication].prescriptionIds?.[0]) }}
          </td>
          <td>{{ groupedMedications[medication].quantity }}</td>
          <td></td>
        </tr>
      </tbody>
    </table>

  </div>
</div>


  <!-- confirm step modal -->
  <!-- Modal -->
  <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">Please select</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          Confirm option and continue.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <!-- <button type="button" class="btn btn-success" printSectionId="printlist" ngxPrint>Print Pick List</button> -->
           <button (click)="triggerPrintPickList()" class="btn btn-success">Print Pick-List</button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Continue</button>
        </div>
      </div>
    </div>
  </div>
  <!-- medicine list -->
  <div id="print-medicines">
    <div id="medicine-list" class="med-container" *ngFor="let medicine of printMedications;">
      <div class="medicine">
        <div class="text-section">
          <p class="child-warning">Keep out of sight & reach of children</p>
          <h4 class="med-name">{{ medicine.medicationName }} {{ medicine.medicineDosage }}</h4>
          <p class="dose-instruction">{{ medicine.instruction }}</p>
        </div>

        <div class="barcode-section">
          <ngx-barcode6 [bc-value]="medicine.medicationId" [bc-display-value]="false" [bc-width]="1" [bc-height]="20">
          </ngx-barcode6>
        </div>
      </div>
    </div>
  </div>
  <!-- (focus)="barcodeInput.select()" -->
  <!-- autofocus
  (blur)="barcodeInput.focus()" -->